// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";
// import "swiper/css/pagination";
// import "swiper/css/virtual";
// import "swiper/css/scrollbar";
// import "swiper/css/effect-fade";

// import {
//   Navigation,
//   Pagination,
//   Autoplay,
//   Virtual,
//   A11y,
//   EffectFade,
// } from "swiper/modules";

// import { Box, Grid, Button } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import _ from "lodash";

// function BannerCarousel({ bgImage }) {
//   // Read from localStorage
//   const localImages = localStorage.getItem("websiteDetails");
//   const parseData = localImages ? JSON.parse(localImages) : null;

//   const images = parseData?.banner || [];

//   // slides MUST always be an array
//   const slides =
//     images.length > 0 ? images : Array.isArray(bgImage) ? bgImage : [bgImage];

//   return (
//     <>
//       <style>
//         {`
//         @media (max-width: 600px) {
//           .desktop-only { display: none !important; }
//           .mobile-only { display: block !important; }
//         }
//         @media (min-width: 601px) {
//           .desktop-only { display: block !important; }
//           .mobile-only { display: none !important; }
//         }
//       `}
//       </style>

//       {/* ----------------------- DESKTOP VERSION ----------------------- */}
//       <Box className="desktop-only">
//         <Swiper
//           style={{ width: "100%", height: "500px" }}
//           modules={[Navigation, Pagination, Autoplay, Virtual, A11y, EffectFade]}
//           effect="fade"
//           virtual
//           slidesPerView={1}
//           navigation
//           autoplay={{ delay: 3000 }}
//           loop
//           pagination={{ clickable: true }}
//         >
//           {slides.map((img, index) => (
//             <SwiperSlide key={index} virtualIndex={index}>
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "500px",
//                   backgroundImage: `url(${img})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   position: "relative",
//                 }}
//               >
//                 {/* Content Box */}
//                 <Grid
//                   container
//                   sx={{
//                     position: "absolute",
//                     top: "20%",
//                     left: "7%",
//                     width: "60%",
//                   }}
//                 >
//                   <Grid
//                     item
//                     md={9}
//                     sm={12}
//                     xs={12}
//                     sx={{
//                       bgcolor: "#ffffff99",
//                       p: 3,
//                       borderRadius: "8px",
//                       backdropFilter: "blur(2px)",
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       alignItems: "flex-start",
//                       zIndex: 2,
//                     }}
//                   >
//                     <span className="title">
//                       Welcome to {_.get(parseData, "store_name", "Our Store")}!
//                     </span>

//                     <Button
//                       sx={{ mt: 2, width: "40%" }}
//                       variant="contained"
//                       endIcon={<SendIcon />}
//                     >
//                       Explore
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Box>

//       {/* ----------------------- MOBILE VERSION ----------------------- */}
//       <Box className="mobile-only">
//         <Swiper
//           style={{ width: "100%", height: "220px" }}
//           autoplay={{ delay: 3000 }}
//           loop
//         >
//           {slides.map((img, index) => (
//             <SwiperSlide key={index}>
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "220px",
//                   backgroundImage: `url(${img})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   position: "relative",
//                 }}
//               >
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{
//                     height: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     p: 2,
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "rgba(0,0,0,0.5)",
//                       padding: "12px 16px",
//                       borderRadius: 8,
//                       color: "#fff",
//                     }}
//                   >
//                     <span style={{ fontSize: "1.2rem" }}>
//                       Welcome to {_.get(parseData, "store_name", "Our Store")}!
//                     </span>

//                     <Button
//                       sx={{ mt: 1 }}
//                       className="explore-btn"
//                       variant="contained"
//                       endIcon={<SendIcon />}
//                     >
//                       Explore
//                     </Button>
//                   </div>
//                 </Grid>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Box>
//     </>
//   );
// }

// export default BannerCarousel;

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
} from "swiper/modules";

import { Box, Grid, Button } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import _ from "lodash";
import { useNavigate } from "react-router-dom";

function BannerCarousel({type}) {
  // Read from localStorage
  const localData = localStorage.getItem("websiteDetails");
  const parseData = localData ? JSON.parse(localData) : null;
  const naviagte =useNavigate()
  // ONLY use localStorage banner images
  const slides = Array.isArray(parseData?.banner) ? parseData.banner : [];

  // // ONLY use localStorage banner images
  // const slides =Array.isArray(parseData?.banner)? parseData?.banner : []
  // type === "contact"
  //   ? parseData?.banner.slice(0,1)
  //   : type === "about"
  //   ? parseData?.banner.slice(0,1)
    // : parseData?.banner || [];

console.log("banner",parseData?.banner.slice(0,1))
  return (
    <>
      <style>
        {`
        @media (max-width: 600px) {
          .desktop-only { display: none !important; }
          .mobile-only { display: block !important; }
        }
        @media (min-width: 601px) {
          .desktop-only { display: block !important; }
          .mobile-only { display: none !important; }
        }
      `}
      </style>

      {/* ----------------------- DESKTOP VERSION ----------------------- */}
      <Box className="desktop-only">
        <Swiper
          style={{ width: "100%", height: "500px" }}
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          navigation
          autoplay={{ delay: 3000 }}
          loop
          pagination={{ clickable: true }}
        >
          {Array.isArray(slides) && slides?.map((img, index) => (
            <SwiperSlide key={index}>
              {/* <Box
                sx={{
                  width: "100%",
                  height: "500px",
                  // backgroundImage: `url(${img})`,
                  //         backgroundSize: "contain",
                  //         backgroundPosition: "center",
                  //         backgroundRepeat: "no-repeat",
                          position: "relative",
                      }}
                  > */}
                <img
                  src={img}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "fill",      // prevents cut-off
                    objectPosition: "center",
                    display: "block",
                  }}
                />
                {/* Content Box */}
                {/* <Grid
                  container
                  sx={{
                    position: "absolute",
                    top: "25%",
                    left: "8%",
                    width: "40%",
                    zIndex: 20,
                  }}
                >
                 {/* {(type==="contact" || type ==="about") ? <></>:index<1? <Grid
                    item
                    xs={12}
                    sx={{
                      width: "100%",
                      bgcolor: "#fff9",
                      p: 3,
                      borderRadius: "6px",
                      backdropFilter: "blur(4px)",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "600",
                        color: "#000",
                      }}
                    >
                      Welcome to {_.get(parseData, "store_name", "Our Store")}!
                    </span>

                    <Button
                      sx={{
                        width: "30%",
                        mt: 3,
                        px: 1,
                        py: 1,
                        fontSize: "0.8rem",
                        borderRadius: "4px",
                      }}
                      variant="contained"
                      onClick={()=>naviagte("/products")}
                      endIcon={<SendIcon />}
                    >
                      Explore
                    </Button>
                  </Grid>:<></>} */}
                {/* </Grid> */} 
              {/* </Box> */}
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      {/* ----------------------- MOBILE VERSION ----------------------- */}
      <Box className="mobile-only">
        <Swiper
          style={{ width: "100%", height: "220px" }}
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{ delay: 3000 }}
          loop
        >
          {slides.map((img, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  width: "100%",
                  height: "220px",
                  backgroundImage: `url(${img})`,
                  backgroundSize: "contain",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          position: "relative",
                }}
              >
                
            {/* {(type==="contact" || type ==="about") ? <></>: index<1 ?   <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    p: 2,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",   
                      background: "#fff9",
                      padding: "14px 18px",
                      borderRadius: 10,
                      color: "#000",
                    }}
                  >
                    <span style={{ fontSize: "1.7rem", fontWeight: 500 }}>
                      Welcome to {_.get(parseData, "store_name", "Our Store")}!
                    </span>

                    <Button
                    
                      sx={{ mt: 1, width: "50%", px: 1, py: 1, fontSize: "0.8rem", borderRadius: "4px" }}
                      variant="contained"
                      size="small"
                      endIcon={<SendIcon />}
                      onClick={()=>naviagte("/products")}
                    >
                      Explore
                    </Button>
                  </div>
                </Grid>:<></>} */}
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </>
  );
}

export default BannerCarousel;
